<template>
  <div :class="$options.name">
    <div class="side-menu">
      <div class="width-100">
        <img :src="publicUrl + '/logo.png'" width="150px" />
      </div>
      <h1 class="title">Welcome to device 360</h1>
      <p>for hardware team</p>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
  export default {
    name: "LayoutDefault",
    components: {},
    data() {
      return {publicUrl: process.env.PUBLIC_URL}
    }
  }
</script>

<style lang="scss" scoped>
  .LayoutDefault {
    display: flex;
    padding: 10%;
    height: 100vh;
  }
  .title {
    font-weight: 200;
  }
  .side-menu {
    border-right: 1px solid #212121;
    align-items: stretch;
    width: 50%;
    padding: 5%;
  }
</style>
